import { request } from '../utils/request';

export const refreshAllAPI = () => request.post(`/admin/cache/refresh-all`);

export const refreshUsersAPI = data =>
  request.post(`/admin/cache/refresh-user`, data);
